import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

const AUTH0_DOMAIN    = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUTH0_AUDIENCE  = process.env.REACT_APP_AUTH0_AUDIENCE;
const AUTH0_ENABLED   = Boolean(AUTH0_DOMAIN && AUTH0_CLIENT_ID);

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppTree = AUTH0_ENABLED ? (
  <Auth0Provider
    domain={AUTH0_DOMAIN}
    clientId={AUTH0_CLIENT_ID}
    useRefreshTokens={true}
    cacheLocation="localstorage"
    authorizationParams={{
      redirect_uri: window.location.origin,
      ...(AUTH0_AUDIENCE ? { audience: AUTH0_AUDIENCE } : {}),
      scope: 'openid profile email',
    }}
  >
    <App />
  </Auth0Provider>
) : (
  // Auth0 not configured — run without authentication (open-dev mode)
  <App />
);

root.render(
  <React.StrictMode>
    {AppTree}
  </React.StrictMode>
);

reportWebVitals();
